import { c as _c } from "react/compiler-runtime";
import { BestOfAwardsBanner } from '@cc-shopping/ui/composites/BestOfAwardsBanner';
import { BEST_OF_AWARDS_WINNERS_MAP } from '@cc-shopping/ui/composites/BestOfAwardsBanner/utils';
import { Box } from '@mui/material';
import Grid from '@mui/material/Grid';
import { useReviewContext } from 'src/app/credit-cards/reviews/components/Context';
import Details from '../components/Details';
import Header from './components/Header';
export default function MobileProductCard() {
  const $ = _c(16);
  const {
    marketplaceEntity: t0
  } = useReviewContext();
  const {
    id: offerId,
    showCTA,
    image
  } = t0;
  const hasAward = !!BEST_OF_AWARDS_WINNERS_MAP[offerId];
  let t1;
  if ($[0] !== offerId) {
    t1 = <BestOfAwardsBanner offerId={offerId} variant="review" isFeatureEnabled={true} />;
    $[0] = offerId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== hasAward) {
    t2 = hasAward && {
      borderTopColor: "transparent"
    };
    $[2] = hasAward;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = {
      rowGap: 3.5,
      border: 1,
      borderColor: "neutral.lighter",
      pb: 3.5,
      width: "auto",
      justifyContent: "center",
      ...t2
    };
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== image || $[7] !== showCTA) {
    t4 = <Header showCTA={showCTA} image={image} />;
    $[6] = image;
    $[7] = showCTA;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Grid container={true} sx={{
      px: 3.5
    }}><Details vertical={true} /></Grid>;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t3 || $[11] !== t4) {
    t6 = <Grid container={true} sx={t3}>{t4}{t5}</Grid>;
    $[10] = t3;
    $[11] = t4;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t1 || $[14] !== t6) {
    t7 = <Box>{t1}{t6}</Box>;
    $[13] = t1;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
}